import React from "react";
import {
  LayoutDashboard,
  Radio,
  BookOpen,
  Users,
  UserCog,
  MessageSquare,
  Settings,
  User,
  LogOut,
  Menu,
  X,
  Home,
  Layers,
  ClipboardCheck,
} from "lucide-react";
import { useAuth } from "src/context/AuthContext";
import Sidebar, { SidebarItemType } from "src/components/ui/Sidebar";
import { ROUTES } from "src/routes/RouteConfig";

const AdminSidebar: React.FC = () => {
  const { signOut } = useAuth();

  const menuItems: SidebarItemType[] = [
    {
      icon: <LayoutDashboard size={18} />,
      label: "Dashboard",
      path: ROUTES.ADMIN_DASHBOARD.path,
    },
    {
      icon: <Radio size={18} />,
      label: "Live View",
      path: ROUTES.ADMIN_LIVE_VIEW.path,
    },
    {
      icon: <BookOpen size={18} />,
      label: "Session Management",
      path: ROUTES.ADMIN_SESSIONS.path,
    },
    {
      icon: <UserCog size={18} />,
      label: "Tutor Management",
      path: ROUTES.ADMIN_TUTORS.path,
    },
    {
      icon: <Users size={18} />,
      label: "User Management",
      path: ROUTES.ADMIN_USERS.path,
    },
    {
      icon: <ClipboardCheck size={18} />,
      label: "Enrollments",
      path: ROUTES.ADMIN_ENROLLMENTS.path,
    },
    {
      icon: <BookOpen size={18} />,
      label: "Curriculum Catalog",
      path: ROUTES.ADMIN_CURRICULUM_CATALOG.path,
    },
    {
      icon: <Layers size={18} />,
      label: "Batch Management",
      path: ROUTES.ADMIN_BATCHES.path,
    },
    {
      icon: <MessageSquare size={18} />,
      label: "Inquiries Management",
      path: ROUTES.ADMIN_INQUIRIES.path,
    },
    {
      icon: <MessageSquare size={18} />,
      label: "Demo Bookings",
      path: ROUTES.ADMIN_DEMO_BOOKINGS.path,
    },
    {
      icon: <Settings size={18} />,
      label: "Update System Information",
      path: "/admin/system",
    },
    {
      icon: <User size={18} />,
      label: "Update Account Details",
      path: "/admin/account",
    },
  ];

  const handleLogout = async () => {
    await signOut();
  };

  return (
    <Sidebar
      title="Admin Portal"
      menuItems={menuItems}
      onLogout={handleLogout}
      logoutIcon={<LogOut size={18} />}
      headerColor="text-rfpurple-800"
      homeLink={ROUTES.ADMIN_DASHBOARD.path}
      homeIcon={<Home size={20} />}
      expandIcon={<Menu size={16} />}
      collapseIcon={<X size={16} />}
    />
  );
};

export default AdminSidebar;
